// Client version check. The build stamps its own id (git SHA) into the bundle
// and into /version.json. A running client polls version.json and, when the
// deployed id differs from its own, knows it's stale and should reload — so a
// long-open tab/PWA doesn't keep writing with a retired UI after a deploy.

const BUILD_ID = (import.meta.env.VITE_BUILD_ID as string | undefined) ?? 'dev';

export function currentBuildId(): string {
  return BUILD_ID;
}

/** True when a newer build is live and the running client is stale. Never true
 *  in dev (no version.json / id 'dev') or when ids match. */
export function isUpdateAvailable(current: string, deployed: string | null): boolean {
  if (!deployed || current === 'dev') return false;
  return deployed !== current;
}

/** Fetch the deployed build id from /version.json (cache-busted). null on any
 *  error (offline, 404 in dev) so callers simply skip the prompt. */
export async function fetchDeployedBuildId(): Promise<string | null> {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const data = (await res.json()) as { build?: string };
    return data.build ?? null;
  } catch {
    return null;
  }
}
